import * as axiosService from "./axiosService";

export const saveAnalyticalData = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/Analytics/SetAnalytics`,payload);
};